import { render, staticRenderFns } from "./SimpleForm.vue?vue&type=template&id=90f71aa0"
import script from "./SimpleForm.vue?vue&type=script&lang=js"
export * from "./SimpleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports